import { IconContext } from '@phosphor-icons/react';
import { ConnectedRouter } from 'connected-react-router';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import './global.scss';
import App from 'containers/App';
import store, { history } from 'reducers';
import ErrorBoundary, { DefaultFallbackComponent } from 'utils/ErrorBoundary';
import tagManagerArgs from 'utils/google-tag-manager';
import locale, { selectLocale } from './utils/intl';

if (process.env.NODE_ENV === 'production') TagManager.initialize(tagManagerArgs);

const rootPath = document.location.pathname
  .split('/')
  .filter((v) => v)
  .shift();
const isSurvey = rootPath === 'surveys';
document.documentElement.style.setProperty('--body-bg', isSurvey ? '#fff4de' : '#f2f2f2');

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');
createRoot(rootEl).render(
  <IntlProvider locale={locale} messages={selectLocale()}>
    <IconContext.Provider value={{ weight: 'light', size: 16 }}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <ErrorBoundary FallbackComponent={DefaultFallbackComponent}>
            <App />
          </ErrorBoundary>
        </ConnectedRouter>
      </Provider>
    </IconContext.Provider>
  </IntlProvider>,
);
